import Component from './TopicFilterSlider';
import Container from './TopicFilterSlider.container';

export default Container(Component);
